(() => {
  const ROOT_SELECTOR = '.pp-col-nav';

  function bindModals(root) {
    const triggers = root.querySelectorAll('[data-pp-modal-open]');
    if (triggers.length === 0) return;

    triggers.forEach((btn) => {
      const name = btn.getAttribute('data-pp-modal-open');
      const modal = document.querySelector(`[data-pp-modal="${name}"]`);
      if (!modal) return;

      btn.addEventListener('click', () => {
        if (typeof modal.showModal === 'function') {
          modal.showModal();
        } else {
          modal.setAttribute('open', '');
        }
      });
    });

    document.querySelectorAll('dialog[data-pp-modal]').forEach((modal) => {
      const closeBtn = modal.querySelector('[data-pp-modal-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          if (typeof modal.close === 'function') {
            modal.close();
          } else {
            modal.removeAttribute('open');
          }
        });
      }

      modal.addEventListener('click', (ev) => {
        if (ev.target === modal) {
          if (typeof modal.close === 'function') {
            modal.close();
          } else {
            modal.removeAttribute('open');
          }
        }
      });
    });
  }

  function init() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(bindModals);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
